import { extend } from 'vee-validate';
import { max } from 'vee-validate/dist/rules';

extend('max', max);
